export { ModuleWrapper, type ModuleWrapperProps } from './ModuleWrapper';
